const authUrlSelector = 'a.auth-url';

function authUrlHandler(e){
    const authUrl = e.target.closest(authUrlSelector);
    if (authUrl){
        const href = authUrl.getAttribute('href');
        authUrl.setAttribute('href', `${href}?lastUrl=${encodeURIComponent(window.location.href)}`);
    }
}

export default authUrlHandler;